import React from 'react';
import Slider from 'rc-slider';
import './style.scss';


const { Handle } = Slider;

const VolumeProgressBar = ({ expected, self, isDarkTheme }) => (
  <div
    className="volumeProgressBar"
    style={{
      height: `${10 + self / 10}%`,
      background: 1000 - self <= expected
        ? 'linear-gradient(to left, #45A4DB, #216BB4)'
        : isDarkTheme ? '#181e26' : '#F1F2F2',
    }}
  />
);

const progressValues = [950, 850, 760, 670, 580, 490, 400, 310, 220, 135, 50];
const VolumeBlock = ({ percent, isDarkTheme }) => (
  <div className="volumeBlock">
    {progressValues.map(value => (
      <VolumeProgressBar
        key={value}
        expected={percent}
        self={value}
        isDarkTheme={isDarkTheme}
      />
    ))}
  </div>
);

class SpeedSlider extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      inputValue: 0,
    };
  }

  onChange = (value) => {
    this.setState({
      inputValue: value,
    });
  };

  interpolate = (value) => {
    if (value <= 333) {
      return 1000 - Math.ceil(value / 333.3334 * 900, 10);
    }
    if (value <= 666) {
      return 180 - Math.ceil(value / 333.3334 * 80, 10);
    }
    return 60 - Math.ceil(value / 333.3334 * 20, 10);
  };

  render() {
    const { isDarkTheme } = this.props;
    const { inputValue } = this.state;
    return (
      <div className="speedSlider noselect">
        <VolumeBlock percent={inputValue} isDarkTheme={isDarkTheme} />
        <Slider
          min={0}
          max={1000}
          handle={(props) => {
            const {
              value, ...restProps
            } = props;
            return (
              <Handle
                value={value}
                {...restProps}
                style={{
                  width: '32px',
                  height: '32px',
                  transform: 'translate(-10px, -8px)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  border: 'none',
                  boxShadow: '0 0 12px rgba(0,0,0,.3)',
                }}
              >
                <p style={{
                  margin: 0,
                  padding: 0,
                  color: '#4A90E2',
                  fontWeight: '900',
                  fontSize: '12px',
                  lineHeight: 2,
                }}
                >
                  {this.interpolate(value)}
                </p>
              </Handle>
            );
          }}
          onChange={this.onChange}
          value={typeof inputValue === 'number' ? inputValue : 0}
        />
        <div className="speedSlider_row noselect">
          <div className="speedSlider_cell">1Gb</div>
          <div className="speedSlider_cell">100M</div>
          <div className="speedSlider_cell">20M</div>
          <div className="speedSlider_cell">0M</div>
        </div>
      </div>
    );
  }
}

export { SpeedSlider };



// WEBPACK FOOTER //
// ./src/view/common/SpeedSlider/index.jsx